import { gql } from '@apollo/client';

export const GET_CORREIOS_CREDENTIALS = gql`
  query GetCorreiosCredentials($storeId: ID!) {
    getCorreiosCredentials(storeId: $storeId) {
      __typename
      ... on GetCorreiosCredentialsSuccess {
        code
        credentials {
          correiosId
          correiosPassword
          correiosAdministrativeCode
          correiosContract
          correiosServiceCode
          correiosPostageCard
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
